export function sanitizeQueryParams(str: string | unknown, limit = 30): string {
  if (typeof str === 'string') {
    return str.replace(/[^a-zA-Z0-9àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕçÇ\s\-\\.+]/g, '').slice(0, limit);
  }
  return '';
}
